module.exports = __webpack_public_path__ + "static/Number 107-52295c84f266cc110ac42ef6908d6c4c.jpg";